import { useHandleTransactionRequest } from "./useHandleTransactionRequest";

type CancelOrderPayload = {
  /** Order ID as a decimal string (u128) */
  orderId: string;
  nonce: number;
};

export const useHandleCancelOrderRequest = () => {
  return useHandleTransactionRequest<CancelOrderPayload>("CancelOrder");
};
